// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCreateSiteResultModelResponse {
    static getAttributeTypeMap() {
        return EnrollmentCreateSiteResultModelResponse.attributeTypeMap;
    }
}
EnrollmentCreateSiteResultModelResponse.discriminator = undefined;
EnrollmentCreateSiteResultModelResponse.additionalProperties = false;
EnrollmentCreateSiteResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentCreateSiteResultModel"
    },
];
//# sourceMappingURL=enrollmentCreateSiteResultModelResponse.js.map